/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useLayoutEffect, useMemo, useRef } from 'react';

export const useContextEffect = ({ cb, ctx, deps }) => {
  const contextRef = useRef(ctx);
  const callbackRef = useRef(cb);
  contextRef.current = ctx;
  callbackRef.current = cb;

  useEffect(() => {
    const ctx = contextRef.current;
    const cleanup = callbackRef.current(ctx);

    return cleanup;
  }, deps);
};

export const useStableCallback = (callback) => {
  const onChangeInner = useRef(callback);
  useLayoutEffect(() => {
    onChangeInner.current = callback;
  });
  const stable = useCallback((...args) => onChangeInner.current(...args), []);
  return stable;
};

export const useContextMemo = ({ cb, ctx, deps }) => {
  const contextRef = useRef(ctx);
  contextRef.current = ctx;

  return useMemo(() => {
    const ctx = contextRef.current;
    return cb(ctx);
  }, deps);
};
